import BaseNormalizer from "./BaseNormalizer";

const merchantAccountsNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "email",
  "firstName",
  "lastName",
  "region",
]);

export default merchantAccountsNormalizer;
